import React from "react";

const Login = () => {
    return (
    <h1>Work in progress!</h1>
    )
}
export default Login;